import React from "react"
import { makeStyles } from '@material-ui/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
});

function createData(cell1, cell2, cell3, cell4, protein1, protein2, protein3, protein4, protein5, protein6, protein7, protein8, protein9, protein10, protein11) {
    return { cell1, cell2, cell3, cell4, protein1, protein2, protein3, protein4, protein5, protein6, protein7, protein8, protein9, protein10, protein11 };
}

const rows = [
    createData(1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16),
    createData(25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400),
    createData(83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200),
    createData(37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103),
    createData(25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400),
    createData(83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200),
    createData(37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103),
    createData(25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400),
    createData(83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200),
    createData(37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103, 37602103),
    createData(25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400, 25475400),
    createData(83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200, 83019200),
]



const TableExample2 = (props) => {
    const { className } = props
    const classes = useStyles();
    return (
        <TableContainer component={Paper} className={className}>
            <Table className={classes.table} size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow>
                        <TableCell align="center">Կոդ</TableCell>
                        <TableCell align="center">Comm</TableCell>
                        <TableCell align="center">Brand</TableCell>
                        <TableCell align="center">Model</TableCell>
                        <TableCell align="center">Col</TableCell>
                        <TableCell align="center">Size</TableCell>
                        <TableCell align="center">Պահեստ</TableCell>
                        <TableCell align="center">Փաթեթ</TableCell>
                        <TableCell align="center">Որակի հսկում</TableCell>
                        <TableCell align="center">ՆՈՀ</TableCell>
                        <TableCell align="center">ՈՀ</TableCell>
                        <TableCell align="center">ՆՈՀ</TableCell>
                        <TableCell align="center">Հոսք</TableCell>
                        <TableCell align="center">Հոսք N</TableCell>
                        <TableCell align="center">Ընդամենը</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <TableRow key={row.cell1}>
                            <TableCell align="center" className="table1Cell" >{row.cell1}</TableCell>
                            <TableCell align="center" className="table1Cell">{row.cell2}</TableCell>
                            <TableCell align="center" className="table1Cell">{row.cell3}</TableCell>
                            <TableCell align="center" className="table1Cell">{row.cell4}</TableCell>
                            <TableCell align="center" className="table1Cell">{row.protein1}</TableCell>
                            <TableCell align="center" className="table1Cell">{row.protein2}</TableCell>
                            <TableCell align="center" className="table1Cell">{row.protein3}</TableCell>
                            <TableCell align="center" className="table1Cell">{row.protein4}</TableCell>
                            <TableCell align="center" className="table1Cell">{row.protein5}</TableCell>
                            <TableCell align="center" className="table1Cell">{row.protein6}</TableCell>
                            <TableCell align="center" className="table1Cell">{row.protein7}</TableCell>
                            <TableCell align="center" className="table1Cell">{row.protein8}</TableCell>
                            <TableCell align="center" className="table1Cell">{row.protein9}</TableCell>
                            <TableCell align="center" className="table1Cell">{row.protein10}</TableCell>
                            <TableCell align="center" className="table1Cell">{row.protein11}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default TableExample2